import React, { Component } from "react";

export class ProductTypeModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ProductTypeModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, show, onClose, modalSize, errorMessage, disableSubmit } =
      props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData
          {...attrs}
          onClose={onClose}
          errorMessage={errorMessage}
          disableSubmit={disableSubmit}
        ></AppFormData>
      </AppCanvas>
    );
  }
}

export default ProductTypeModal;
